import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Action } from 'redux';
import { SetActiveProfile } from '../action-creators';
import { SetActiveArtist } from '@webapp/store/artist/action-creators';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';
import AppState from '@webapp/store/state';
import { setBeaconIdentity } from '@webapp/utils/helpscout/indentify';

export const setArtistToActiveProfileEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, SetActiveArtist>(SET_ACTIVE_ARTIST),
    withLatestFrom(state$),
    map(([action, state]) => {
      setBeaconIdentity({
        artistName: action.artist.name,
        doj: state.user.profile?.created_at?.toISOString() ?? '',
        email: state.user.profile?.email ?? '',
        userId: state.user.profile?.id ?? '',
        name: state.user.profile?.fullName ?? '',
      });
      return new SetActiveProfile(true, action.artist.id as string);
    })
  );
